// extracted by mini-css-extract-plugin
module.exports = {"dialog":"login-frame_dialog__2OtjH"};